import { Injectable } from '@angular/core';
import { Store } from '@karma-games/angular-devkit/src/lib/extended-store';
import { HttpService } from '@karma-games/angular-devkit/src/lib/services/http';
import { map } from 'rxjs/operators';
import { IAutoPlayRepository } from './interfaces';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AutoPlayRepository implements IAutoPlayRepository {
    constructor(
        protected store: Store,
        protected http: HttpService
    ) {
    }

    getUserWallet(): Observable<number> {
        return this.http.get('players/me/balance').pipe(map(res => res.body.data as number));
    }
}
